/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Carousel from './modules/carousel';
import FlowDiagram from './modules/flow-diagram';
import Header from './modules/header';
import ListSlide from './modules/list-slide';
import ImgSlide from './modules/img-slide';
import TextSlide from './modules/text-slide';
import HomeSlide from './modules/home-slide';
import CardSlide from './modules/card-slide';
import SupWrap from './modules/sup-wrap';
import Parallax from './modules/parallax';
import OffsetParallax from './modules/offsetParallax';
import Icon from './modules/icon';
import Modal from './modules/modal';
import Map from './modules/map';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'header':

                        let headerInstance = new Header(item);

                        headerInstance.init();

                        break;

                    case 'carousel':

                        let carouselInstance = new Carousel(item);

                        carouselInstance.init();

                        break;

                    case 'flow-diagram':

                        let flowDiagramInstance = new FlowDiagram(item);

                        flowDiagramInstance.init();

                        break;

                    case 'list-slide':

                        let listSlideModule = new ListSlide(item);

                        listSlideModule.init();

                        break;

                    case 'home-slide':

                        let homeSlideModule = new HomeSlide(item);

                        homeSlideModule.init();

                        break;

                    case 'img-slide':

                        let imgSlideModule = new ImgSlide(item);

                        imgSlideModule.init();

                        break;

                    case 'card-slide':

                        let cardSlideModule = new CardSlide(item);

                        cardSlideModule.init();

                        break;

                    case 'text-slide':

                        let textSlideModule = new TextSlide(item);

                        textSlideModule.init();

                        break;

                    case 'sub-wrap':

                        let supWrapModule = new SupWrap(item);

                        supWrapModule.init();

                        break;

                    case 'parallax':

                        let parallaxModule = new Parallax(item);

                        parallaxModule.init();

                        break;

                    case 'offset-parallax':

                        let offsetParallaxModule = new OffsetParallax(item);

                        offsetParallaxModule.init();

                        break;

                    case 'icon':

                        let iconModule = new Icon(item);

                        iconModule.init();

                        break;

                    case 'modal':

                        let modalModule = new Modal(item);

                        modalModule.init();

                        break;

                    case 'map':

                        let mapModule = new Map(item);

                        mapModule.init();

                        break;
                }
            });
        });
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
